var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.8C14.25 4.16994 14.25 3.85491 14.3726 3.61426C14.4805 3.40258 14.6526 3.23048 14.8643 3.12262C15.1049 3 15.4199 3 16.05 3H19.2C19.8301 3 20.1451 3 20.3857 3.12262C20.5974 3.23048 20.7695 3.40258 20.8774 3.61426C21 3.85491 21 4.16994 21 4.8V7.95C21 8.58006 21 8.89509 20.8774 9.13574C20.7695 9.34742 20.5974 9.51952 20.3857 9.62738C20.1451 9.75 19.8301 9.75 19.2 9.75H16.05C15.4199 9.75 15.1049 9.75 14.8643 9.62738C14.6526 9.51952 14.4805 9.34742 14.3726 9.13574C14.25 8.89509 14.25 8.58006 14.25 7.95V4.8Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.8C3 4.16994 3 3.85491 3.12262 3.61426C3.23048 3.40258 3.40258 3.23048 3.61426 3.12262C3.85491 3 4.16994 3 4.8 3H7.95C8.58006 3 8.89509 3 9.13574 3.12262C9.34742 3.23048 9.51952 3.40258 9.62738 3.61426C9.75 3.85491 9.75 4.16994 9.75 4.8V7.95C9.75 8.58006 9.75 8.89509 9.62738 9.13574C9.51952 9.34742 9.34742 9.51952 9.13574 9.62738C8.89509 9.75 8.58006 9.75 7.95 9.75H4.8C4.16994 9.75 3.85491 9.75 3.61426 9.62738C3.40258 9.51952 3.23048 9.34742 3.12262 9.13574C3 8.89509 3 8.58006 3 7.95V4.8Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.05C3 15.4199 3 15.1049 3.12262 14.8643C3.23048 14.6526 3.40258 14.4805 3.61426 14.3726C3.85491 14.25 4.16994 14.25 4.8 14.25H7.95C8.58006 14.25 8.89509 14.25 9.13574 14.3726C9.34742 14.4805 9.51952 14.6526 9.62738 14.8643C9.75 15.1049 9.75 15.4199 9.75 16.05V19.2C9.75 19.8301 9.75 20.1451 9.62738 20.3857C9.51952 20.5974 9.34742 20.7695 9.13574 20.8774C8.89509 21 8.58006 21 7.95 21H4.8C4.16994 21 3.85491 21 3.61426 20.8774C3.40258 20.7695 3.23048 20.5974 3.12262 20.3857C3 20.1451 3 19.8301 3 19.2V16.05Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16.05C14.25 15.4199 14.25 15.1049 14.3726 14.8643C14.4805 14.6526 14.6526 14.4805 14.8643 14.3726C15.1049 14.25 15.4199 14.25 16.05 14.25H19.2C19.8301 14.25 20.1451 14.25 20.3857 14.3726C20.5974 14.4805 20.7695 14.6526 20.8774 14.8643C21 15.1049 21 15.4199 21 16.05V19.2C21 19.8301 21 20.1451 20.8774 20.3857C20.7695 20.5974 20.5974 20.7695 20.3857 20.8774C20.1451 21 19.8301 21 19.2 21H16.05C15.4199 21 15.1049 21 14.8643 20.8774C14.6526 20.7695 14.4805 20.5974 14.3726 20.3857C14.25 20.1451 14.25 19.8301 14.25 19.2V16.05Z",
    stroke: "#595959",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/dashboard-black.de60818d73f3d0149185920ead5c5a6f.svg";
export { ForwardRef as ReactComponent };